import { useQuery } from '@tanstack/react-query';

import { GridPaginationModel } from '@mui/x-data-grid';

import { getServiceFeeList } from '~/services/BusinessTraveller/BusinessTravellerService';

export const serviceFeeQueryKeys = {
  all: ['service-fees'],
  list: (businessId: string, paginationModel?: GridPaginationModel) => [
    ...serviceFeeQueryKeys.all,
    'list',
    businessId,
    paginationModel ?? 'all',
  ],
};

/**
 * Fetches service fees for a business.
 * Fetch whole list when paginationModel is not provided.
 */
export function useGetServiceFees(businessId: string, paginationModel?: GridPaginationModel) {
  return useQuery({
    queryKey: serviceFeeQueryKeys.list(businessId, paginationModel),
    queryFn: () => getServiceFeeList(businessId, paginationModel),
    enabled: !!businessId,
  });
}
